import filterableDeviceAttrsProps from './filterableDeviceAttrsProps'

interface submitFilterFormProps {
  data: any
  filters: Array<filterableDeviceAttrsProps>
  handleFilter: Function
  setActiveFiltersCount: Function
  searchAllCustomers: boolean
  setCurrentFilter: Function
  setCurrentFilterRawData: Function
}

const changeType = (value: any, dataType: any): any => {
  switch (dataType) {
    case Number:
      value = parseInt(value)
      break
  }
  return value
}

const submitFilterForm = async (props: submitFilterFormProps) => {
  props.setCurrentFilterRawData(props.data)
  let activeFiltersCount = 0
  let filter: object = {}
  //transform fiters to backend compatible objects
  for (const [key, value] of Object.entries(props.data)) {
    if (![undefined, '', null].includes(value as any)) {
      const filterOperator = props.filters.find((obj) => {
        return obj.name === key
      })
      if (filterOperator === undefined) {
        continue
      }
      const filteredProp: any = value
      //we expect 'id' any the identity column for object entries
      let filterVal: any = filteredProp.hasOwnProperty('id') ? filteredProp?.id : value

      if (Array.isArray(filterVal)) {
        let filteredVals: Array<any> = []
        filterVal.forEach((entry: any) => {
          //we expect 'id' any the identity column for object entries
          let multiFilterVal: any = entry.hasOwnProperty('id') ? entry?.id : entry
          multiFilterVal = changeType(multiFilterVal, filterOperator.dataType)
          filteredVals.push(multiFilterVal)
        })
        if (filteredVals.length < 1) {
          continue
        }
        filterVal = filteredVals
      } else {
        filterVal = changeType(filterVal, filterOperator.dataType)
      }

      activeFiltersCount++
      filter[key] = { [filterOperator.operator]: filterVal }
    }
  }

  if (props.searchAllCustomers) {
    filter['search_all_customers'] = { '=': 1 }
  }

  props.setActiveFiltersCount(activeFiltersCount)
  props.setCurrentFilter(filter)
  props.handleFilter(filter)
}

export default submitFilterForm
